module.exports = __webpack_public_path__ + "static/media/user-1.e03a6f46.jpg";